import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance, AxiosResponse } from 'axios';
import { type ApiError, useLegacyAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

type SuccessResponse = AxiosResponse<{ message: string }>;

export async function manuallySyncExternalEmails(axiosInstance: Promise<AxiosInstance>) {
  const instance = await axiosInstance;

  return instance.post('fetch_external_mails');
}

export function useManuallySyncExternalMails() {
  const client = useQueryClient();
  const axiosInstance = useLegacyAxiosInstance();

  const mutation = useMutation<SuccessResponse, ApiError>({
    mutationFn: () => manuallySyncExternalEmails(axiosInstance),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['mails'] });
    },
  });

  return addActionNameToMutationResult<
    SuccessResponse,
    ApiError,
    void,
    'manuallySyncExternalEmails'
  >('manuallySyncExternalEmails', mutation);
}
